import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app'

import { Home } from './Home'

export const homeRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/',
    component: Home,
})
